import React, { useMemo, useState } from 'react';

import Button from 'components/shared/Button/Button';

import { TYPE_SIGNATURE_FONTS } from '../lib/constants';

const TypefaceDropdown = ({ fontId, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);

  const items = useMemo(
    () => TYPE_SIGNATURE_FONTS.map((font) => ({ label: font.label, value: font.id })),
    []
  );

  const selected =
    TYPE_SIGNATURE_FONTS.find((font) => font.id === fontId) || TYPE_SIGNATURE_FONTS[0];

  return (
    <Button.Dropdown
      open={isOpen}
      setOpen={setIsOpen}
      variant="link"
      color="neutral"
      shade={700}
      size="small"
      text={selected.label}
      textClassName="text-sm font-medium normal-case"
      className="pl-3 pr-2"
      iconRight="chevron-down-linear"
      iconClassName={isOpen ? 'rotate-180 transition-transform' : 'transition-transform'}
      items={items}
      active={fontId}
      onClick={(item) => onChange?.(item.value)}
    />
  );
};

export default TypefaceDropdown;
